import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import categoryReducer from "../redux/features/categoryAndType/categoryAndTypeSlice";
import postReducer from "../redux/features/post/postSlice";
import voteReducer from "../redux/features/vote/voteSlice";
import addReducer from "../redux/features/add/addSlice";
import filterReducer from "./features/post/filterSlice";
// import orderReducer from "../redux/features/order/orderSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    category: categoryReducer,
    post: postReducer,
    add: addReducer,
    vote: voteReducer,
    filter: filterReducer,
    // order: orderReducer,
  },
});
